// import React, { useState, useEffect } from "react";
// import { FormattedMessage } from "react-intl";

// // styles
// import Styles from "./createBeneficiaryModal.module.css";

// // redux
// import { useSelector, useDispatch } from "react-redux";
// import { _createBeneficiary } from "../../../profile/redux/actions";
// import { _getCurrencies } from "../../deposit-withdraw/redux/actions";
// import { addBeneficiary } from "../../../../redux/slices/beneficiariesSlice";

// // components
// import Input from "../../../../components/Input/Input";
// import Button from "../../../../components/Button/Button";
// import WenbitModal from "../../../../components/Modal/Modal";
// import SelectCoinInput from "../../../../components/Input/SelectCoinInput/SelectCoinInput";
// // No Select import needed, using Input with type="select"

// // utils
// import {
//   showErrorSnackbar,
//   showSuccessSnackbar
// } from "../../../snackbar/helpers";
// import { hideCreateBeneficiaryModal } from "./helpers";

// // form validation
// import * as Yup from "yup";
// import { useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { API } from "../../../../utility/API";

// function CreateBeneficiaryModal() {
//   const dispatch = useDispatch()
//   const modalOpen = useSelector(
//     (state) => state.createBeneficiaryModalState.open
//   )
//   const modalData = useSelector(
//     (state) => state.createBeneficiaryModalState.data
//   )
//   const currencies = useSelector((state) => state.currencies.value)

//   const [selectedBeneficiaryCoinID, setSelectedBeneficiaryCoinID] = useState(
//     modalData.selectedCoin ?? "LINK" // Default to LINK
//   )
//   const [loading, setLoading] = useState(false)
//   const [buttonLoading, setButtonLoading] = useState(false)
//   const [isFiatCurrency, setIsFiatCurrency] = useState(false)
//   const [formKey, setFormKey] = useState(0) // Used to force re-render the form
//   const [disclaimerChecked, setDisclaimerChecked] = useState(false)

//   // Step management
//   const [currentStep, setCurrentStep] = useState(1)

//   // Payment method states
//   const [paymentMethods, setPaymentMethods] = useState([])
//   const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null)
//   const [paymentMethodDetails, setPaymentMethodDetails] = useState(null)
//   const [paymentMethodsLoading, setPaymentMethodsLoading] = useState(false)
//   const [paymentMethodDetailsLoading, setPaymentMethodDetailsLoading] = useState(false)

//   // Network state handling (for crypto)
//   const [networkOptions, setNetworkOptions] = useState([])
//   const [selectedNetwork, setSelectedNetwork] = useState("")
//   const [networkLoading, setNetworkLoading] = useState(false)

//   // Step 1 validation schema (basic info + payment method)
//   const step1Schema = Yup.object().shape({
//     name: Yup.string()
//       .required("Beneficiary name is required")
//       .min(2, "Beneficiary name must be at least 2 characters")
//       .max(64, "Beneficiary name must be 64 characters or less"),
//     description: Yup.string().max(255),
//     payment_method: Yup.string().required("Payment method selection is required")
//   })

//   // Dynamic validation schema for step 2 based on payment method details
//   const createStep2Schema = () => {
//     const schemaFields = {
//       // Always include step 1 fields in step 2 validation
//       name: Yup.string()
//         .required("Beneficiary name is required")
//         .min(2, "Beneficiary name must be at least 2 characters")
//         .max(64, "Beneficiary name must be 64 characters or less"),
//       description: Yup.string().max(255),
//       payment_method: Yup.string().required("Payment method selection is required")
//     }

//     // For crypto currencies, add address and network validation
//     if (!isFiatCurrency) {
//       schemaFields.address = Yup.string()
//         .required("Beneficiary address is required")
//         .min(10, "Address must be at least 10 characters")

//       schemaFields.network = Yup.string()
//         .required("Network is required")
//     }

//     // Add dynamic fields from payment method details
//     if (paymentMethodDetails?.payment_method_details) {
//       paymentMethodDetails.payment_method_details.forEach(field => {
//         const fieldName = field.field_name

//         // Skip address and network for crypto as they're handled above
//         if (!isFiatCurrency && ['address', 'network'].includes(fieldName.toLowerCase())) {
//           return
//         }

//         // Create validation rules based on field name
//         switch (fieldName.toLowerCase()) {
//           case 'address':
//             schemaFields[fieldName] = Yup.string()
//               .required(`${fieldName} is required`)
//               .min(10, "Address must be at least 10 characters")
//             break
//           case 'network':
//             schemaFields[fieldName] = Yup.string()
//               .required(`${fieldName} is required`)
//             break
//           case 'relation':
//             schemaFields[fieldName] = Yup.string()
//               .required(`${fieldName} is required`)
//             break
//           case 'bank_name':
//             schemaFields[fieldName] = Yup.string()
//               .required(`${fieldName} is required`)
//               .min(2, "Bank name must be at least 2 characters")
//               .max(100, "Bank name must be 100 characters or less")
//             break
//           case 'bank_code':
//           case 'iban':
//           case 'account_number':
//             schemaFields[fieldName] = Yup.string()
//               .required(`${fieldName} is required`)
//             break
//           case 'sort_code':
//             schemaFields[fieldName] = Yup.string()
//               .required(`${fieldName} is required`)
//               .matches(/^\d{2}-\d{2}-\d{2}$/, "Sort code must be in format XX-XX-XX")
//             break
//           case 'swift_bic':
//             schemaFields[fieldName] = Yup.string()
//               .required(`${fieldName} is required`)
//               .matches(/^[A-Z0-9]{8,11}$/, "Invalid SWIFT/BIC format")
//             break
//           case 'bank_address':
//             schemaFields[fieldName] = Yup.string()
//               .required(`${fieldName} is required`)
//               .min(5, "Bank address must be at least 5 characters")
//             break
//           case 'bank_country':
//             schemaFields[fieldName] = Yup.string()
//               .required(`${fieldName} is required`)
//             break
//           case 'acc_holder_full_name':
//             schemaFields[fieldName] = Yup.string()
//               .required(`${fieldName} is required`)
//               .min(2, "Account holder name must be at least 2 characters")
//               .max(100, "Account holder name must be 100 characters or less")
//             break
//           default:
//             schemaFields[fieldName] = Yup.string()
//               .required(`${fieldName} is required`)
//         }
//       })
//     }

//     return Yup.object().shape(schemaFields)
//   }

//   // Initialize form with appropriate schema based on current step
//   const getCurrentSchema = () => {
//     if (currentStep === 1) {
//       return step1Schema
//     } else {
//       return createStep2Schema()
//     }
//   }

//   const {
//     register,
//     handleSubmit,
//     formState: { errors, isValid, isDirty, isSubmitting },
//     reset,
//     trigger,
//     getValues,
//     setValue,
//     clearErrors,
//     watch
//   } = useForm({
//     resolver: yupResolver(getCurrentSchema()),
//     mode: "onChange",
//     reValidateMode: "onChange"
//   })

//   // Function to fetch payment methods for a currency
//   const fetchPaymentMethods = async (currencyId) => {
//     if (!currencyId) return

//     setPaymentMethodsLoading(true)
//     try {
//       const response = await API.get(`/trading/account/beneficiaries/payment_methods?currency=${currencyId}`)
//       console.log(response)
//       // Response is directly an array, not wrapped in data property
//       if (response) {
//         // Transform the response to match expected structure
//         const transformedPaymentMethods = response.data.map(item => ({
//           id: item.payment_method_id,
//           name: item.payment_method.name,
//           icon_url: item.payment_method.icon_url,
//           description: item.payment_method.description,
//           payment_type: item.payment_method.payment_type,
//           fee_percentage: item.payment_method.fee_percentage,
//           position: item.payment_method.position
//         }))
//         console.log(transformedPaymentMethods)
//         setPaymentMethods(transformedPaymentMethods)

//         // Auto-select first payment method if only one is available
//         if (transformedPaymentMethods.length === 1) {
//           const firstPaymentMethod = transformedPaymentMethods[0]
//           setSelectedPaymentMethod(firstPaymentMethod)
//           setValue("payment_method", firstPaymentMethod.id.toString())

//           // Call handlePaymentMethodChange to fetch details and trigger logging
//           handlePaymentMethodChange(null, firstPaymentMethod.id.toString())
//         }
//       } else {
//         setPaymentMethods([])
//       }
//     } catch (error) {
//       console.error("Error fetching payment methods:", error)
//       if (modalOpen) {
//         showErrorSnackbar({
//           alertMessage: "Failed to fetch payment methods for this currency"
//         })
//       }
//       setPaymentMethods([])
//     } finally {
//       setPaymentMethodsLoading(false)
//     }
//   }

//   // Function to fetch payment method details
//   const fetchPaymentMethodDetails = async (paymentMethodId) => {
//     if (!paymentMethodId) return

//     setPaymentMethodDetailsLoading(true)
//     try {
//       const response = await API.get(`/trading/account/beneficiaries/payment_method?payment_method_id=${paymentMethodId}`)

//       if (response.data) {
//         setPaymentMethodDetails(response.data)

//         // If it's a crypto payment method, also fetch networks if not already fetched
//         if (!isFiatCurrency && selectedBeneficiaryCoinID && networkOptions.length === 0) {
//           await fetchNetworks(selectedBeneficiaryCoinID)
//         }
//       } else {
//         setPaymentMethodDetails(null)
//       }
//     } catch (error) {
//       console.error("Error fetching payment method details:", error)
//       if (modalOpen) {
//         showErrorSnackbar({
//           alertMessage: "Failed to fetch payment method details"
//         })
//       }
//       setPaymentMethodDetails(null)
//     } finally {
//       setPaymentMethodDetailsLoading(false)
//     }
//   }

//   // Function to fetch networks for a given currency (for crypto)
//   const fetchNetworks = async (currencyId) => {
//     if (!currencyId) return

//     setNetworkLoading(true)
//     try {
//       const response = await API.get(`/trading/account/beneficiaries/networks/${currencyId}`)

//       if (response.data && Array.isArray(response.data) && response.data.length > 0) {
//         const options = response.data.map((network) => ({
//           value: network,
//           label: network
//         }))

//         const networkSelectOptions = [
//           { value: "", label: "Select Network" },
//           ...options
//         ]

//         setNetworkOptions(networkSelectOptions)

//         // Select the first network by default
//         if (options.length > 0) {
//           setSelectedNetwork(options[0].value)
//           setValue("network", options[0].value)
//         }
//       } else {
//         setNetworkOptions([])
//         setSelectedNetwork("")
//         setValue("network", "")
//       }
//     } catch (error) {
//       console.error("Error fetching networks:", error)
//       if (modalOpen) {
//         showErrorSnackbar({
//           alertMessage: "Failed to fetch networks for this currency"
//         })
//       }
//       setNetworkOptions([])
//       setSelectedNetwork("")
//       setValue("network", "")
//     } finally {
//       setNetworkLoading(false)
//     }
//   }

//   // Update currency type and fetch payment methods when selection changes
//   useEffect(() => {
//     if (!selectedBeneficiaryCoinID) return

//     const selectedCurrency = currencies.find(c => c.id === selectedBeneficiaryCoinID)
//     const isFiat = selectedCurrency?.type === 'fiat'

//     // Update currency type if it has changed
//     if (isFiat !== isFiatCurrency) {
//       setIsFiatCurrency(isFiat)
//       // Reset payment method selection when currency type changes
//       setSelectedPaymentMethod(null)
//       setPaymentMethodDetails(null)
//       setValue("payment_method", "")

//       // Reset form with updated schema
//       if (currentStep === 1) {
//         reset({}, {
//           resolver: yupResolver(step1Schema),
//           keepDefaultValues: false
//         })
//       }
//     }

//     // Always fetch payment methods for the selected currency
//     fetchPaymentMethods(selectedBeneficiaryCoinID)

//     // For crypto currencies, also fetch networks
//     if (!isFiat) {
//       fetchNetworks(selectedBeneficiaryCoinID)
//     } else {
//       // Clear networks for fiat currencies
//       setNetworkOptions([])
//       setSelectedNetwork("")
//       setValue("network", "")
//     }
//   }, [selectedBeneficiaryCoinID, currencies.length])

//   // Update form resolver when step changes or payment method details change
//   useEffect(() => {
//     const newResolver = yupResolver(getCurrentSchema())
//     reset(getValues(), {
//       resolver: newResolver,
//       keepValues: true,
//       keepErrors: false
//     })
//   }, [currentStep, paymentMethodDetails])

//   // Handle payment method selection
//   const handlePaymentMethodChange = (e, value) => {
//     const paymentMethodId = value
//     const paymentMethod = paymentMethods.find(pm => pm.id.toString() === paymentMethodId)

//     setSelectedPaymentMethod(paymentMethod)
//     setValue("payment_method", paymentMethodId)
//     clearErrors("payment_method")
//     console.log("=================================================")
//     console.log(paymentMethodId)
//     console.log(paymentMethod)
//     console.log("=================================================")

//     if (paymentMethodId) {
//       fetchPaymentMethodDetails(paymentMethodId)
//     } else {
//       setPaymentMethodDetails(null)
//     }
//   }

//   // Validate fields for current step
//   const validateFields = async () => {
//     const result = await trigger()
//     return result
//   }

//   // Handle step 1 submission (proceed to step 2)
//   const handleStep1Submit = async (formData) => {
//     const isFormValid = await validateFields()
//     if (!isFormValid) {
//       showErrorSnackbar({
//         alertMessage: "Please fill in all required fields correctly"
//       })
//       return
//     }

//     if (!selectedPaymentMethod) {
//       showErrorSnackbar({
//         alertMessage: "Please select a payment method"
//       })
//       return
//     }

//     // Store step 1 data
//     const step1Data = {
//       name: formData.name,
//       description: formData.description,
//       payment_method: selectedPaymentMethod.id.toString()
//     }

//     // Move to step 2 and preserve step 1 data
//     setCurrentStep(2)

//     // Reset form with step 2 schema but preserve step 1 data
//     setTimeout(() => {
//       reset(step1Data, {
//         resolver: yupResolver(createStep2Schema()),
//         keepValues: false
//       })
//       setFormKey(prev => prev + 1)
//     }, 50)
//   }

//   // Handle final submission (step 2)
//   const onFinalSubmit = async (formData) => {
//     const isFormValid = await validateFields()
//     if (!isFormValid) {
//       showErrorSnackbar({
//         alertMessage: "Please fill in all required fields correctly"
//       })
//       return
//     }

//     // Check if disclaimer is checked
//     if (!disclaimerChecked) {
//       showErrorSnackbar({
//         alertMessage: "Please acknowledge the disclaimer"
//       })
//       return
//     }

//     setLoading(true)
//     setButtonLoading(true)

//     // Get all form data including hidden fields
//     const allFormData = getValues()

//     const beneficiaryData = {
//       currency: selectedBeneficiaryCoinID,
//       name: allFormData.name || formData.name,
//       description: allFormData.description || formData.description || "",
//       payment_method_id: selectedPaymentMethod.id
//     }

//     // Build data field based on currency type and payment method details
//     const dataFields = {}

//     // For crypto currencies, include address in data
//     if (!isFiatCurrency && (allFormData.address || formData.address)) {
//       dataFields.address = allFormData.address || formData.address
//     }

//     // Add other fields from payment method details
//     if (paymentMethodDetails?.payment_method_details) {
//       paymentMethodDetails.payment_method_details.forEach(field => {
//         const fieldName = field.field_name

//         // Skip address for crypto as it's handled above, and skip network as it's not in data
//         if (fieldName.toLowerCase() === 'address' && !isFiatCurrency) {
//           return
//         }
//         if (fieldName.toLowerCase() === 'network') {
//           return
//         }

//         if (allFormData[fieldName] || formData[fieldName]) {
//           dataFields[fieldName] = allFormData[fieldName] || formData[fieldName]
//         }
//       })
//     }

//     // Add network for crypto currencies (as separate field, not in data)
//     if (!isFiatCurrency && (allFormData.network || formData.network)) {
//       beneficiaryData.network = allFormData.network || formData.network
//     }

//     beneficiaryData.data = JSON.stringify(dataFields)

//     _createBeneficiary(
//       beneficiaryData,
//       (data) => {
//         setLoading(false)
//         setButtonLoading(false)
//         dispatch(addBeneficiary(data))
//         showSuccessSnackbar({
//           alertMessage: "Beneficiary Successfully Created"
//         })
//         hideCreateBeneficiaryModal()
//         if (modalData.callback) {
//           modalData.callback()
//         }
//       },
//       (error) => {
//         console.log(error)
//         setLoading(false)
//         setButtonLoading(false)
//         if (error) {
//           showErrorSnackbar({
//             alertMessage: error?.errors?.[0]?.length ? (
//               <FormattedMessage id={error.errors} />
//             ) : (
//               "Unknown Error"
//             )
//           })
//         }
//       }
//     )
//   }

//   // Reset modal state when opened/closed
//   useEffect(() => {
//     if (modalOpen) {
//       // Set selected coin when modal opens
//       if (modalData.selectedCoin) {
//         setSelectedBeneficiaryCoinID(modalData.selectedCoin)
//       } else {
//         // If no coin specified, set default and fetch currencies if needed
//         if (currencies.length > 0) {
//           const linkCurrency = currencies.find(c => c.id === "LINK")
//           if (linkCurrency) {
//             setSelectedBeneficiaryCoinID("LINK")
//           } else {
//             setSelectedBeneficiaryCoinID(currencies[0]?.id)
//           }
//         } else {
//           // Fetch currencies and set default
//           _getCurrencies((data) => {
//             const linkCurrency = data.find(c => c.id === "LINK")
//             if (linkCurrency) {
//               setSelectedBeneficiaryCoinID("LINK")
//             } else {
//               setSelectedBeneficiaryCoinID(data[0]?.id)
//             }
//           })
//         }
//       }
//     }

//     if (!modalOpen) {
//       // Reset all states
//       setCurrentStep(1)
//       setSelectedPaymentMethod(null)
//       setPaymentMethodDetails(null)
//       setPaymentMethods([])
//       setNetworkOptions([])
//       setSelectedNetwork("")
//       reset()
//       setDisclaimerChecked(false)
//     }
//   }, [modalOpen, modalData, currencies.length])

//   // Fetch payment methods when modal opens and coin is set
//   useEffect(() => {
//     if (modalOpen && selectedBeneficiaryCoinID) {
//       fetchPaymentMethods(selectedBeneficiaryCoinID)
//     }
//   }, [modalOpen, selectedBeneficiaryCoinID])

//   // Handle network selection change
//   const handleNetworkChange = (e, value) => {
//     setSelectedNetwork(value)
//     setValue("network", value)
//     clearErrors("network")
//   }

//   // Handle country selection change
//   const handleCountryChange = (countryCode) => {
//     setValue(countryCode.target.name, countryCode.target.value)
//     clearErrors(countryCode.target.name)
//   }

//   // Handle disclaimer checkbox change
//   const handleDisclaimerChange = (e) => {
//     setDisclaimerChecked(e.target.checked)
//   }

//   // Handle back button
//   const handleBackToStep1 = () => {
//     // Get current form data
//     const currentData = getValues()

//     // Prepare step 1 data
//     const step1Data = {
//       name: currentData.name || "",
//       description: currentData.description || "",
//       payment_method: selectedPaymentMethod?.id?.toString() || ""
//     }

//     // Move back to step 1
//     setCurrentStep(1)

//     // Reset form with step 1 schema and data
//     setTimeout(() => {
//       reset(step1Data, {
//         resolver: yupResolver(step1Schema),
//         keepValues: false
//       })
//       setFormKey(prev => prev + 1)
//     }, 50)
//   }

//   // Render payment method field options
//   const renderPaymentMethodField = (field) => {
//     const fieldName = field.field_name
//     const fieldLabel = field.field_name.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())

//     switch (fieldName.toLowerCase()) {
//       case 'network':
//         return (
//           <Input
//             key={fieldName}
//             type="select"
//             name={fieldName}
//             inputLabel="Network"
//             onChange={handleNetworkChange}
//             selectValue={selectedNetwork}
//             selectOptions={networkOptions}
//             error={errors[fieldName]}
//             errorMessage={errors[fieldName]?.message}
//             isLoading={networkLoading}
//             disabled={networkLoading}
//             placeholder="Select network"
//             inputIconContainerStyle={{
//               border: "1px var(--border-color) solid",
//               borderRadius: 5,
//               background: "var(--secondary-color)",
//               marginBottom: "20px"
//             }}
//             showBorder
//             required
//           />
//         )

//       case 'bank_country':
//         return (
//           <div key={fieldName}>
//             <Input
//               type="country"
//               name={fieldName}
//               inputLabel="Bank Country"
//               placeholder="Select bank country"
//               onChange={handleCountryChange}
//               error={errors[fieldName]}
//               errorMessage={errors[fieldName]?.message}
//               inputIconContainerStyle={{
//                 border: "1px var(--border-color) solid",
//                 borderRadius: 5,
//                 background: "var(--secondary-color)",
//                 marginBottom: "20px"
//               }}
//               required
//             />
//             <input
//               type="hidden"
//               {...register(fieldName)}
//             />
//           </div>
//         )

//       default:
//         return (
//           <Input
//             key={fieldName}
//             inputLabel={fieldLabel}
//             placeholder={`Enter ${fieldLabel.toLowerCase()}`}
//             showBorder
//             error={errors[fieldName]}
//             errorMessage={errors[fieldName]?.message}
//             required
//             {...register(fieldName)}
//           />
//         )
//     }
//   }

//   return (
//     <>
//       <WenbitModal
//         open={modalOpen}
//         showCloseButton={true}
//         onClose={hideCreateBeneficiaryModal}
//         title="Manage Beneficiaries"
//         render={() => (
//           <div>
//             {currentStep === 1 ? (
//               // Step 1: Basic info and payment method selection
//               <form key={formKey} onSubmit={handleSubmit(handleStep1Submit)} noValidate>
//                 <SelectCoinInput
//                   onChange={(coin) => {
//                     setSelectedBeneficiaryCoinID(coin?.id)
//                   }}
//                   coinId={selectedBeneficiaryCoinID}
//                 />

//                 <Input
//                   inputLabel="Beneficiary Reference Name"
//                   placeholder="Beneficiary reference name"
//                   showBorder
//                   error={errors.name}
//                   errorMessage={errors.name?.message}
//                   required
//                   {...register("name")}
//                 />

//                 <Input
//                   inputLabel="Beneficiary Description"
//                   placeholder="Beneficiary description"
//                   showBorder
//                   error={errors.description}
//                   errorMessage={errors.description?.message}
//                   {...register("description")}
//                 />

//                 <div className={Styles.formSectionTitle}>
//                   <h5>Choose Payment method:</h5>
//                 </div>

//                 {paymentMethodsLoading ? (
//                   <div style={{ textAlign: 'center', padding: '20px' }}>
//                     Loading payment methods...
//                   </div>
//                 ) : (
//                   <div className={Styles.paymentMethodsContainer}>
//                     {paymentMethods.map((method) => (
//                       <label
//                         key={method.id}
//                         className={Styles.paymentMethodOption}
//                       >
//                         <input
//                           type="radio"
//                           name="payment_method"
//                           value={method.id}
//                           checked={selectedPaymentMethod?.id === method.id}
//                           onChange={(e) => handlePaymentMethodChange(e, method.id.toString())}
//                           className={Styles.paymentMethodRadio}
//                         />
//                         <div className={Styles.paymentMethodName}>
//                           {method.name}
//                           {method.fee_percentage && (
//                             <div className={Styles.feePercentage}>
//                               Fee: {method.fee_percentage}%
//                             </div>
//                           )}
//                         </div>
//                         <div className={Styles.paymentMethodIcon}>
//                           {method.icon_url ? (
//                             <img src={method.icon_url} alt={method.name} />
//                           ) : (
//                             <div className={Styles.defaultIcon}>
//                               {method.name.charAt(0)}
//                             </div>
//                           )}
//                         </div>
//                       </label>
//                     ))}
//                   </div>
//                 )}

//                 <input
//                   type="hidden"
//                   {...register("payment_method")}
//                   value={selectedPaymentMethod?.id || ""}
//                 />

//                 {errors.payment_method && (
//                   <div className={Styles.errorMessage}>
//                     {errors.payment_method.message}
//                   </div>
//                 )}

//                 <Button
//                   text="Confirm"
//                   disabled={loading || isSubmitting || paymentMethodsLoading || !selectedPaymentMethod}
//                   isLoading={buttonLoading}
//                   type="submit"
//                   style={{ marginTop: "20px" }}
//                 />
//               </form>
//             ) : (
//               // Step 2: Payment method specific fields
//               <form key={formKey} onSubmit={handleSubmit(onFinalSubmit)} noValidate>
//                 {/* Show step 1 fields - still editable */}
//                 <SelectCoinInput
//                   onChange={(coin) => {
//                     setSelectedBeneficiaryCoinID(coin?.id)
//                   }}
//                   coinId={selectedBeneficiaryCoinID}
//                 />

//                 <Input
//                   inputLabel="Beneficiary Reference Name"
//                   placeholder="Beneficiary reference name"
//                   showBorder
//                   error={errors.name}
//                   errorMessage={errors.name?.message}
//                   required
//                   {...register("name")}
//                 />

//                 <Input
//                   inputLabel="Beneficiary Description"
//                   placeholder="Beneficiary description"
//                   showBorder
//                   error={errors.description}
//                   errorMessage={errors.description?.message}
//                   {...register("description")}
//                 />

//                 <div className={Styles.formSectionTitle}>
//                   <h5>Choose Payment method:</h5>
//                 </div>

//                 {paymentMethodsLoading ? (
//                   <div style={{ textAlign: 'center', padding: '20px' }}>
//                     Loading payment methods...
//                   </div>
//                 ) : (
//                   <div className={Styles.paymentMethodsContainer}>
//                     {paymentMethods.map((method) => (
//                       <label
//                         key={method.id}
//                         className={Styles.paymentMethodOption}
//                       >
//                         <input
//                           type="radio"
//                           name="payment_method"
//                           value={method.id}
//                           checked={selectedPaymentMethod?.id === method.id}
//                           onChange={(e) => handlePaymentMethodChange(e, method.id.toString())}
//                           className={Styles.paymentMethodRadio}
//                         />
//                         <div className={Styles.paymentMethodName}>
//                           {method.name}
//                           {method.fee_percentage && (
//                             <div className={Styles.feePercentage}>
//                               Fee: {method.fee_percentage}%
//                             </div>
//                           )}
//                         </div>
//                         <div className={Styles.paymentMethodIcon}>
//                           {method.icon_url ? (
//                             <img src={method.icon_url} alt={method.name} />
//                           ) : (
//                             <div className={Styles.defaultIcon}>
//                               {method.name.charAt(0)}
//                             </div>
//                           )}
//                         </div>
//                       </label>
//                     ))}
//                   </div>
//                 )}

//                 <input
//                   type="hidden"
//                   {...register("payment_method")}
//                   value={selectedPaymentMethod?.id || ""}
//                 />

//                 {paymentMethodDetailsLoading ? (
//                   <div style={{ textAlign: 'center', padding: '20px' }}>
//                     Loading payment method details...
//                   </div>
//                 ) : (
//                   <>
//                     {/* For crypto currencies, always show address field */}
//                     {!isFiatCurrency && (
//                       <Input
//                         inputLabel="Beneficiary Address"
//                         placeholder="Enter beneficiary address"
//                         showBorder
//                         error={errors.address}
//                         errorMessage={errors.address?.message}
//                         required
//                         {...register("address")}
//                       />
//                     )}

//                     {/* For crypto currencies, show network field */}
//                     {!isFiatCurrency && (
//                       <Input
//                         type="select"
//                         name="network"
//                         inputLabel="Network"
//                         onChange={handleNetworkChange}
//                         selectValue={selectedNetwork}
//                         selectOptions={networkOptions}
//                         error={errors.network}
//                         errorMessage={errors.network?.message}
//                         isLoading={networkLoading}
//                         disabled={networkLoading}
//                         placeholder="Select network"
//                         inputIconContainerStyle={{
//                           border: "1px var(--border-color) solid",
//                           borderRadius: 5,
//                           background: "var(--secondary-color)",
//                           marginBottom: "20px"
//                         }}
//                         showBorder
//                         required
//                       />
//                     )}

//                     {/* Render additional dynamic fields from payment method details */}
//                     {paymentMethodDetails?.payment_method_details
//                       ?.filter(field => !['address', 'network'].includes(field.field_name.toLowerCase()))
//                       ?.map(field => renderPaymentMethodField(field))}

//                     {/* Hidden input for network */}
//                     <input type="hidden" {...register("network")} value={selectedNetwork} />

//                     {/* Disclaimer checkbox */}
//                     <div className={Styles.disclaimerContainer}>
//                       <div className={Styles.checkbox}>
//                         <input
//                           type="checkbox"
//                           id="disclaimer-checkbox"
//                           checked={disclaimerChecked}
//                           onChange={handleDisclaimerChange}
//                         />
//                         <label htmlFor="disclaimer-checkbox">
//                           <span className={Styles.disclaimerText}>
//                             Disclaimer: By creating a beneficiary, you confirm that all wallet addresses / accounts and beneficiary details provided are accurate and belong to the intended recipient. You acknowledge that it is your sole responsibility to verify and ensure the correctness of this information. The company shall not be held liable for any loss, delay, or misdirection of funds resulting from incorrect, incomplete, or fraudulent beneficiary details.
//                           </span>
//                         </label>
//                       </div>
//                     </div>

//                     <div className={Styles.buttonContainer}>
//                       <Button
//                         text="Back"
//                         onClick={handleBackToStep1}
//                         style={{ marginTop: "20px", marginRight: "10px" }}
//                         variant="outlined"
//                       />
//                       <Button
//                         text="Confirm"
//                         disabled={loading || isSubmitting || paymentMethodDetailsLoading || !disclaimerChecked}
//                         isLoading={buttonLoading}
//                         type="submit"
//                         style={{ marginTop: "20px" }}
//                       />
//                     </div>
//                   </>
//                 )}
//               </form>
//             )}
//           </div>
//         )}
//       />
//     </>
//   )
// }

// export default CreateBeneficiaryModal


import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";

// styles
import Styles from "./createBeneficiaryModal.module.css";

// redux
import { useSelector, useDispatch } from "react-redux";
import { _createBeneficiary } from "../../../profile/redux/actions";
import { _getCurrencies } from "../../deposit-withdraw/redux/actions";
import { addBeneficiary } from "../../../../redux/slices/beneficiariesSlice";

// components
import Input from "../../../../components/Input/Input";
import Button from "../../../../components/Button/Button";
import WenbitModal from "../../../../components/Modal/Modal";
import SelectCoinInput from "../../../../components/Input/SelectCoinInput/SelectCoinInput";
// No Select import needed, using Input with type="select"

// utils
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from "../../../snackbar/helpers";
import { hideCreateBeneficiaryModal } from "./helpers";

// form validation
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { API } from "../../../../utility/API";

function CreateBeneficiaryModal() {
  const dispatch = useDispatch()
  const modalOpen = useSelector(
    (state) => state.createBeneficiaryModalState.open
  )
  const modalData = useSelector(
    (state) => state.createBeneficiaryModalState.data
  )
  const currencies = useSelector((state) => state.currencies.value)

  const [selectedBeneficiaryCoinID, setSelectedBeneficiaryCoinID] = useState(
    modalData.selectedCoin ?? "LINK" // Default to LINK
  )
  const [loading, setLoading] = useState(false)
  const [buttonLoading, setButtonLoading] = useState(false)
  const [isFiatCurrency, setIsFiatCurrency] = useState(false)
  const [formKey, setFormKey] = useState(0) // Used to force re-render the form
  const [disclaimerChecked, setDisclaimerChecked] = useState(false)

  // Network state handling
  const [networkOptions, setNetworkOptions] = useState([])
  const [selectedNetwork, setSelectedNetwork] = useState("")
  const [networkLoading, setNetworkLoading] = useState(false)

  // Fiat validation schema
  const fiatSchema = Yup.object().shape({
    bank_name: Yup.string()
      .required("Bank name is required")
      .min(2, "Bank name must be at least 2 characters")
      .max(100, "Bank name must be 100 characters or less"),
    bank_code: Yup.string()
      .required("Bank code is required")
      .matches(/^[A-Za-z0-9]+$/, "Bank code must contain only letters and numbers"),
    sort_code: Yup.string()
      .when('$isGBP', {
        is: true,
        then: (schema) => schema
          .required("Sort code is required for GBP")
          .matches(/^\d{2}-\d{2}-\d{2}$/, "Sort code must be in format XX-XX-XX"),
        otherwise: (schema) => schema.notRequired()
      }),
    swift_bic: Yup.string()
      .required("SWIFT/BIC is required")
      .matches(/^[A-Z0-9]{8,11}$/, "Invalid SWIFT/BIC format"),
    bank_address: Yup.string()
      .required("Bank address is required")
      .min(5, "Bank address must be at least 5 characters"),
    bank_country: Yup.string()
      .required("Bank country is required"),
    acc_holder_full_name: Yup.string()
      .required("Account holder name is required")
      .min(2, "Account holder name must be at least 2 characters")
      .max(100, "Account holder name must be 100 characters or less"),
    name: Yup.string()
      .required("Beneficiary name is required")
      .min(2, "Beneficiary name must be at least 2 characters")
      .max(64, "Beneficiary name must be 64 characters or less"),
    description: Yup.string().max(255)
  })

  // Crypto validation schema with network validation
  const cryptoSchema = Yup.object().shape({
    address: Yup.string()
      .required("Address is required")
      .min(10, "Address must be at least 10 characters"),
    name: Yup.string()
      .required("Name is required")
      .min(2, "Name must be at least 2 characters")
      .max(64, "Name must be 64 characters or less"),
    description: Yup.string().max(255),
    network: Yup.string().required("Network selection is required")
  })

  // Initialize form with appropriate schema based on currency type
  const {
    register,
    handleSubmit,
    formState: { errors, isValid, isDirty, isSubmitting },
    reset,
    trigger,
    getValues,
    setValue,
    clearErrors,
    watch
  } = useForm({
    resolver: yupResolver(isFiatCurrency ? fiatSchema : cryptoSchema),
    mode: "onChange", // Validate on change instead of just on submit
    reValidateMode: "onChange"
  })

  // Function to fetch networks for a given currency
  const fetchNetworks = async (currencyId) => {
    if (!currencyId) return

    setNetworkLoading(true)
    try {
      const response = await API.get(`/trading/account/beneficiaries/networks/${currencyId}`)
      // console.log("Networks response:", response.data)

      if (response.data && Array.isArray(response.data) && response.data.length > 0) {
        // Transform network data into options for the dropdown
        const options = response.data.map((network, index) => ({
          value: network,
          label: network
        }))

        // Add a default "Select Network" option
        const networkSelectOptions = [
          { value: "", label: "Select Network" },
          ...options
        ]

        setNetworkOptions(networkSelectOptions)

        // Select the first network by default
        if (options.length > 0) {
          setSelectedNetwork(options[0].value)
          setValue("network", options[0].value)
        }
      } else {
        // console.log("No networks available for this currency")
        setNetworkOptions([])
        setSelectedNetwork("")
        setValue("network", "")
      }
    } catch (error) {
      // console.error("Error fetching networks:", error)
      if (modalOpen) {
        showErrorSnackbar({
          alertMessage: "Failed to fetch networks for this currency"
        })
      }
      setNetworkOptions([])
      setSelectedNetwork("")
      setValue("network", "")
    } finally {
      setNetworkLoading(false)
    }
  }

  // Update currency type and schema when selection changes
  useEffect(() => {
    if (!selectedBeneficiaryCoinID) return

    // Even if modal is closed, we should fetch networks for default coin
    const selectedCurrency = currencies.find(c => c.id === selectedBeneficiaryCoinID)
    const isFiat = selectedCurrency?.type === 'fiat'

    // console.log("Currency selected:", selectedCurrency)
    // console.log("Is Fiat:", isFiat)

    // Only update if the currency type has changed
    if (isFiat !== isFiatCurrency) {
      setIsFiatCurrency(isFiat)

      // Reset form with the appropriate schema
      reset({}, {
        resolver: yupResolver(isFiat ? fiatSchema : cryptoSchema),
        keepDefaultValues: false
      })

      // Force re-render to ensure all form fields are registered properly
      setFormKey(prev => prev + 1)
    }
    // if (modalOpen) {
    // If not a fiat currency, fetch the networks
    if (!isFiat) {
      fetchNetworks(selectedBeneficiaryCoinID)
    } else {
      setNetworkOptions([])
      setSelectedNetwork("")
    }
    // }
  }, [selectedBeneficiaryCoinID, currencies])

  // Load default networks if LINK is selected by default
  useEffect(() => {
    if (currencies.length > 0 && selectedBeneficiaryCoinID === "LINK") {
      const selectedCurrency = currencies.find(c => c.id === "LINK")
      if (selectedCurrency && selectedCurrency.type !== 'fiat') {
        fetchNetworks("LINK")
      }
    }
  }, [currencies])

  const validateFields = async () => {
    // Manually trigger validation on all fields
    const result = await trigger()
    return result
  }

  const onSubmit = async (formData) => {
    // console.log("Form submission attempted with data:", formData)

    // Double-check form validation
    const isFormValid = await validateFields()
    if (!isFormValid) {
      // console.log("Form validation failed", errors)
      showErrorSnackbar({
        alertMessage: "Please fill in all required fields correctly"
      })
      return
    }

    // Check if disclaimer is checked
    if (!disclaimerChecked) {
      showErrorSnackbar({
        alertMessage: "Please acknowledge the disclaimer"
      })
      return
    }

    setLoading(true)
    setButtonLoading(true)

    const beneficiaryData = {
      currency: selectedBeneficiaryCoinID,
      name: formData.name,
      description: formData.description || ""
    }

    // Add data field based on currency type
    if (isFiatCurrency) {
      const bankData = {
        bank_code: formData.bank_code,
        bank_name: formData.bank_name,
        swift_bic: formData.swift_bic,
        bank_address: formData.bank_address,
        bank_country: formData.bank_country,
        acc_holder_full_name: formData.acc_holder_full_name
      }
      console.log(selectedBeneficiaryCoinID)
      // Add sort code only if currency is GBP
      if (selectedBeneficiaryCoinID === 'gbp' && formData.sort_code) {
        bankData.sort_code = formData.sort_code
      }

      beneficiaryData.data = JSON.stringify(bankData)

      // Validate required fiat fields
      const requiredFields = ['bank_code', 'bank_name', 'swift_bic', 'bank_address', 'bank_country', 'acc_holder_full_name']
      if (selectedBeneficiaryCoinID === 'gbp') {
        requiredFields.push('sort_code')
      }
      const missingFields = requiredFields.filter(field => !formData[field])

      if (missingFields.length > 0) {
        setLoading(false)
        setButtonLoading(false)
        showErrorSnackbar({
          alertMessage: `Missing required fields: ${missingFields.join(', ')}`
        })
        return
      }
    } else {
      // For crypto, include network in the data
      beneficiaryData.data = JSON.stringify({
        address: formData.address
      })

      // Add network field for crypto currencies from the selected network
      if (formData.network) {
        beneficiaryData.network = formData.network
      } else {
        setLoading(false)
        setButtonLoading(false)
        showErrorSnackbar({
          alertMessage: "Network selection is required"
        })
        return
      }

      // Validate required crypto fields
      if (!formData.address) {
        setLoading(false)
        setButtonLoading(false)
        showErrorSnackbar({
          alertMessage: "Address is required"
        })
        return
      }
    }

    // console.log("Sending beneficiary data:", beneficiaryData)

    _createBeneficiary(
      beneficiaryData,
      (data) => {
        setLoading(false)
        setButtonLoading(false)
        dispatch(addBeneficiary(data))
        showSuccessSnackbar({
          alertMessage: "Beneficiary Successfully Created"
        })
        hideCreateBeneficiaryModal()
        if (modalData.callback) {
          modalData.callback()
        }
      },
      (error) => {
        console.log(error)
        setLoading(false)
        setButtonLoading(false)
        if (error) {
          showErrorSnackbar({
            alertMessage: error?.errors?.[0]?.length ? (
              <FormattedMessage id={error.errors} />
            ) : (
              "Unknown Error"
            )
          })
        }
      }
    )
  }

  useEffect(() => {
    if (modalOpen && modalData.selectedCoin) {
      setSelectedBeneficiaryCoinID(modalData.selectedCoin)
    }
    if (!modalOpen) {
      reset()
      setDisclaimerChecked(false)
      if (!modalData.selectedCoin && currencies.length > 0) {
        // Default to LINK if available
        const linkCurrency = currencies.find(c => c.id === "LINK")
        if (linkCurrency) {
          setSelectedBeneficiaryCoinID("LINK")
        } else {
          setSelectedBeneficiaryCoinID(currencies[0]?.id)
        }
      } else if (!modalData.selectedCoin) {
        _getCurrencies((data) => {
          // Default to LINK if available
          const linkCurrency = data.find(c => c.id === "LINK")
          if (linkCurrency) {
            setSelectedBeneficiaryCoinID("LINK")
          } else {
            setSelectedBeneficiaryCoinID(data[0]?.id)
          }
        })
      }
    }
  }, [modalOpen, modalData, currencies.length])

  // Handle network selection change
  const handleNetworkChange = (e, value) => {
    setSelectedNetwork(value)
    setValue("network", value)
    clearErrors("network")
  }

  // Handle country selection change
  const handleCountryChange = (countryCode) => {
    // console.log("Country changed to:", countryCode.target.value)
    setValue("bank_country", countryCode.target.value)
    clearErrors("bank_country")
  }

  // Handle disclaimer checkbox change
  const handleDisclaimerChange = (e) => {
    setDisclaimerChecked(e.target.checked)
  }

  return (
    <>
      <WenbitModal
        open={modalOpen}
        showCloseButton={true}
        onClose={hideCreateBeneficiaryModal}
        title="Manage Beneficiaries"
        render={() => (
          <form key={formKey} onSubmit={handleSubmit(onSubmit)} noValidate>
            <SelectCoinInput
              onChange={(coin) => {
                setSelectedBeneficiaryCoinID(coin?.id)
              }}
              coinId={selectedBeneficiaryCoinID}
            />

            <Input
              inputLabel="Beneficiary reference name"
              placeholder="Beneficiary reference name"
              showBorder
              error={errors.name}
              errorMessage={errors.name?.message}
              required
              {...register("name")}
            />

            <Input
              inputLabel="Beneficiary description (optional)"
              placeholder="Beneficiary description"
              showBorder
              error={errors.description}
              errorMessage={errors.description?.message}
              {...register("description")}
            />

            {isFiatCurrency ? (
              // Fiat beneficiary fields
              <>
                <div className={Styles.formSectionTitle}>
                  <h5>Bank Information</h5>
                </div>

                <Input
                  inputLabel="Bank Name"
                  placeholder="Enter bank name"
                  showBorder
                  error={errors.bank_name}
                  errorMessage={errors.bank_name?.message}
                  required
                  {...register("bank_name")}
                />

                <Input
                  inputLabel="IBAN/Account Number"
                  placeholder="Enter bank code"
                  showBorder
                  error={errors.bank_code}
                  errorMessage={errors.bank_code?.message}
                  required
                  {...register("bank_code")}
                />

                {selectedBeneficiaryCoinID === 'gbp' && (
                  <Input
                    inputLabel="Sort Code"
                    placeholder="Enter sort code (XX-XX-XX)"
                    showBorder
                    error={errors.sort_code}
                    errorMessage={errors.sort_code?.message}
                    required
                    {...register("sort_code")}
                  />
                )}

                <Input
                  inputLabel="SWIFT/BIC"
                  placeholder="Enter SWIFT or BIC code"
                  showBorder
                  error={errors.swift_bic}
                  errorMessage={errors.swift_bic?.message}
                  required
                  {...register("swift_bic")}
                />

                <Input
                  inputLabel="Bank Address"
                  placeholder="Enter bank address"
                  showBorder
                  error={errors.bank_address}
                  errorMessage={errors.bank_address?.message}
                  required
                  {...register("bank_address")}
                />

                <Input
                  type="country"
                  name="bank_country"
                  inputLabel="Bank Country"
                  placeholder="Select bank country"
                  onChange={handleCountryChange}
                  error={errors.bank_country}
                  errorMessage={errors.bank_country?.message}
                  inputIconContainerStyle={{
                    border: "1px var(--border-color) solid",
                    borderRadius: 5,
                    background: "var(--secondary-color)",
                    marginBottom: "20px"
                  }}
                  required
                />
                {/* Register bank_country with react-hook-form but let the Input component control the value */}
                <input
                  type="hidden"
                  {...register("bank_country")}
                />

                <Input
                  inputLabel="Account Holder Full Name"
                  placeholder="Enter account holder's full name"
                  showBorder
                  error={errors.acc_holder_full_name}
                  errorMessage={errors.acc_holder_full_name?.message}
                  required
                  {...register("acc_holder_full_name")}
                />
              </>
            ) : (
              // Crypto beneficiary fields
              <>
                <Input
                  inputLabel="Beneficiary address"
                  placeholder="Beneficiary address"
                  showBorder
                  error={errors.address}
                  errorMessage={errors.address?.message}
                  required
                  {...register("address")}
                />

                {/* Network dropdown for crypto currencies */}
                <Input
                  type="select"
                  name="network"
                  inputLabel="Network"
                  onChange={handleNetworkChange}
                  selectValue={selectedNetwork}
                  selectOptions={networkOptions}
                  error={errors.network}
                  errorMessage={errors.network?.message}
                  isLoading={networkLoading}
                  disabled={networkLoading}
                  placeholder="Select network"
                  inputIconContainerStyle={{
                    border: "1px var(--border-color) solid",
                    borderRadius: 5,
                    background: "var(--secondary-color)",
                    marginBottom: "20px"
                  }}
                  showBorder
                  required
                />
                <input
                  type="hidden"
                  {...register("network")}
                  value={selectedNetwork}
                />
              </>
            )}

            {/* Disclaimer checkbox */}
            <div className={Styles.disclaimerContainer}>
              <div className={Styles.checkbox}>
                <input
                  type="checkbox"
                  id="disclaimer-checkbox"
                  checked={disclaimerChecked}
                  onChange={handleDisclaimerChange}
                />
                <label htmlFor="disclaimer-checkbox">
                  <span className={Styles.disclaimerText}>
                    Disclaimer: By creating a beneficiary, you confirm that all wallet addresses / accounts and beneficiary details provided are accurate and belong to the intended recipient. You acknowledge that it is your sole responsibility to verify and ensure the correctness of this information. The company shall not be held liable for any loss, delay, or misdirection of funds resulting from incorrect, incomplete, or fraudulent beneficiary details.
                  </span>
                </label>
              </div>
            </div>

            <Button
              text="Confirm"
              disabled={loading || isSubmitting || (networkLoading && !isFiatCurrency) || !disclaimerChecked}
              isLoading={buttonLoading}
              type="submit"
              style={{ marginTop: "20px" }}
            />
          </form>
        )}
      />
    </>
  )
}

export default CreateBeneficiaryModal